import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';

export function useRushRaffleRounds(enabled = true) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushRaffleRounds,
    queryFn: () => apiClient.api.rushRaffleControllerGetRounds(),
    enabled,
    refetchOnMount: 'always',
    placeholderData: keepPreviousData,
  });
}

export function useRushRaffleRoundDetail(roundId: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushRaffleRoundDetail(roundId),
    queryFn: roundId ? () => apiClient.api.rushRaffleControllerGetRoundDetail(roundId) : skipToken,
    refetchOnMount: 'always',
    refetchInterval: 60_000,
  });
}

export function useRushRaffleMatchAward(matchId: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushRaffleMatchAward(matchId),
    queryFn: matchId ? () => apiClient.api.rushRaffleControllerGetMatchAward(matchId) : skipToken,
  });
}

export function useRushRaffleWinners(enabled = true) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.rushRaffleWinners,
    queryFn: () => apiClient.api.rushRaffleControllerGetWinners(),
    enabled,
    refetchOnMount: 'always',
  });
}
